var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('a',{staticClass:"logo-link"},[_c('img',{staticClass:"logo-img",attrs:{"alt":"logo","src":require("@/assets/icon-survey.svg")}}),_c('span',{staticClass:"logo-text"},[_vm._v(_vm._s(_vm.$t('logo')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }